import type { Localized } from '../types/funnel';

export interface PackingProduct {
  id: string;
  kind: 'packed' | 'empty' | 'materials' | 'review';
  boxes: number;
  label: Localized;
  description: Localized;
  /** Approved price only. null = not approved, never shown or charged online. */
  price: number | null;
  includesLabor: boolean;
}

export const packingCatalog: PackingProduct[] = [
  {
    id: 'packed_5',
    kind: 'packed',
    boxes: 5,
    label: { en: '5 boxes packed by our crew', es: '5 cajas empacadas por nuestro equipo' },
    description: { en: 'Cartons, paper, wrapping and labels', es: 'Cajas, papel, envoltura y etiquetas' },
    price: null,
    includesLabor: true,
  },
  {
    id: 'packed_10',
    kind: 'packed',
    boxes: 10,
    label: { en: '10 boxes packed by our crew', es: '10 cajas empacadas por nuestro equipo' },
    description: { en: 'Cartons, paper, wrapping and labels', es: 'Cajas, papel, envoltura y etiquetas' },
    price: null,
    includesLabor: true,
  },
  {
    id: 'empty_5',
    kind: 'empty',
    boxes: 5,
    label: { en: '5 empty moving boxes', es: '5 cajas vacías' },
    description: { en: 'Delivered for you to pack', es: 'Se las dejamos para que usted empaque' },
    price: null,
    includesLabor: false,
  },
  {
    id: 'empty_10',
    kind: 'empty',
    boxes: 10,
    label: { en: '10 empty moving boxes', es: '10 cajas vacías' },
    description: { en: 'Delivered for you to pack', es: 'Se las dejamos para que usted empaque' },
    price: null,
    includesLabor: false,
  },
  {
    id: 'dish_kit',
    kind: 'materials',
    boxes: 0,
    label: { en: 'Dish-pack carton with dividers', es: 'Caja para platos con divisores' },
    description: { en: 'Keeps plates and glasses upright', es: 'Mantiene platos y vasos en posición vertical' },
    price: null,
    includesLabor: false,
  },
  {
    id: 'custom_review',
    kind: 'review',
    boxes: 0,
    label: { en: 'Kitchen, art or whole-home packing', es: 'Empaque de cocina, arte o toda la casa' },
    description: { en: 'Our team scopes it with you', es: 'Nuestro equipo lo revisa con usted' },
    price: null,
    includesLabor: true,
  },
];
